import { useNode } from "@craftjs/core";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/components/editor/shared/block-wrapper";
import { PaddingWrapper } from "@/components/editor/themes/crosby/constants";

import { VideoAndParagraphList } from "./video-with-paragraph-component-styles";

type VideoWithParagraphProps = {
  children: React.ReactNode;
};
export default function VideoWithParagraph(props: VideoWithParagraphProps) {
  const {
    id,
    connectors: { connect },
  } = useNode();

  return (
    <BlockBackgroundColorWrapper ref={connect} id={id}>
      <PaddingWrapper>
        <BlockMaxWidthWrapper>
          <VideoAndParagraphList>{props.children}</VideoAndParagraphList>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

VideoWithParagraph.craft = {
  isCanvas: true,
  custom: {
    displayName: "Video with title and text",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
